<template>
    <div>
        <div class="p-6 pb-0">
            <BreadCrumbs :navigation="navigation" />
        </div>

        <!-- Tabella dettagli azienda -->
        <div class="p-6 pb-0">
            <div class="bg-white rounded-md shadow-lg p-4">
                <div class="grid grid-cols-3 gap-4 py-4">
                    <div>
                        <label class="block text-gray-700 font-bold">Ragione sociale</label>
                        <p class="text-gray-900">{{ dettagliAzienda.CompanyName }}</p>
                    </div>
                    <div>
                        <label class="block text-gray-700 font-bold">Indirizzo</label>
                        <p class="text-gray-900">{{ dettagliAzienda.Address }}</p>
                    </div>
                    <div>
                        <label class="block text-gray-700 font-bold">Città</label>
                        <p class="text-gray-900">{{ dettagliAzienda.City }}</p>
                    </div>
                </div>
                <div class="grid grid-cols-3 gap-4">
                    <div>
                        <label class="block text-gray-700 font-bold">Codice postale</label>
                        <p class="text-gray-900">{{ dettagliAzienda.ZIPCode }}</p>
                    </div>
                    <div>
                        <label class="block text-gray-700 font-bold">Telefono 1</label>
                        <p class="text-gray-900">{{ dettagliAzienda.Telephone1 }}</p>
                    </div>
                    <div>
                        <label class="block text-gray-700 font-bold">Telefono 2</label>
                        <p class="text-gray-900">{{ dettagliAzienda.Telephone2 }}</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- tabella situazione rate -->
        <div class="p-6 pb-0">
            <div class="bg-white rounded-md shadow-lg p-4">
                <div class="grid grid-cols-5 gap-4 py-4">
                    <div>
                        <label class="block text-gray-700 font-bold">Saldo</label>
                        <p>{{ formatCurrency(situazioneCliente.Saldo) }}</p>
                    </div>
                    <div>
                        <label class="block text-gray-700 font-bold">Totale fatt. a scadere</label>
                        <p>{{ formatCurrency(situazioneCliente.TotaleAScadere) }}</p>
                    </div>
                    <div>
                        <label class="block text-gray-700 font-bold">Totale fatt. scaduto</label>
                        <p class="text-red">{{ formatCurrency(situazioneCliente.TotaleScaduto) }}</p>
                    </div>
                    <div>
                        <label class="block text-gray-700 font-bold">Note credito attive</label>
                        <p>{{ formatCurrency(situazioneCliente.NoteCreditoAttive) }}</p>
                    </div>
                    <div>
                        <label class="block text-gray-700 font-bold">Note credito scadute</label>
                        <p class="text-red">{{ formatCurrency(situazioneCliente.NoteCreditoScadute) }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="p-6 pb-8">
            <!-- Filtri -->
            <div class="flex items-center gap-4 mb-4">
                <div>
                    <label class="block text-gray-700 text-sm mb-1">Data Inizio</label>
                    <Datepicker v-model="dataInizio" :locale="dateLocale" :inputFormat="dateFormat"
                        class="p93__input_general px-3 py-2" :clearable="true" />
                </div>
                <div>
                    <label class="block text-gray-700 text-sm mb-1">Data Fine</label>
                    <Datepicker v-model="dataFine" :locale="dateLocale" :inputFormat="dateFormat"
                        class="p93__input_general px-3 py-2" :clearable="true" />
                </div>
                <div class="flex items-center gap-2 mt-6">
                    <label class="flex items-center cursor-pointer">
                        <input v-model="hideSettledItems" type="checkbox" class="sr-only" />
                        <div class="relative">
                            <div :class="hideSettledItems ? 'bg-green-500' : 'bg-gray-600'"
                                class="block w-14 h-8 rounded-full transition-colors"></div>
                            <div :class="hideSettledItems ? 'translate-x-6' : 'translate-x-0'"
                                class="absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition"></div>
                        </div>
                        <span class="ml-2 text-sm">Nascondi partite saldate</span>
                    </label>
                </div>
                <div class="flex items-center gap-2 mt-6">
                    <label class="flex items-center cursor-pointer">
                        <input v-model="showLinkedSupplierItems" type="checkbox" class="sr-only" />
                        <div class="relative">
                            <div :class="showLinkedSupplierItems ? 'bg-green-500' : 'bg-gray-600'"
                                class="block w-14 h-8 rounded-full transition-colors"></div>
                            <div :class="showLinkedSupplierItems ? 'translate-x-6' : 'translate-x-0'"
                                class="absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition"></div>
                        </div>
                        <span class="ml-2 text-sm">Partite fornitore collegate</span>
                    </label>
                </div>
                <div class="ml-auto text-sm text-gray-600">
                    {{ filteredRate.length }} risultati totali
                </div>
            </div>

            <!-- Legenda colori -->
            <div class="flex items-center gap-6 mb-4 text-sm">
                <div class="flex items-center gap-2" v-if="showLinkedSupplierItems">
                    <span class="w-4 h-4 inline-block rounded bg-yellow-50 border border-yellow-400"></span>
                    <span>Fornitore collegato</span>
                </div>
                <div class="flex items-center gap-2">
                    <span class="w-4 h-4 inline-block rounded bg-red-50 border border-red-400"></span>
                    <span>Nota di credito</span>
                </div>
            </div>

            <table class="min-w-full bg-white rounded-md shadow-lg">
                <thead>
                    <tr>
                        <SortableTableHeader title="Data Scadenza" field="InstallmentDate" :currentSortField="sortField"
                            :sortDirection="sortDirection" @sort="sort" />
                        <SortableTableHeader title="Numero Documento" field="DocNo" :currentSortField="sortField"
                            :sortDirection="sortDirection" @sort="sort" />
                        <SortableTableHeader title="Data Documento" field="DocumentDate" :currentSortField="sortField"
                            :sortDirection="sortDirection" @sort="sort" />
                        <th class="py-2 px-4 border-b text-left">Descrizione</th>
                        <SortableTableHeader title="Importo" field="Amount" :currentSortField="sortField"
                            :sortDirection="sortDirection" @sort="sort" />
                        <SortableTableHeader title="Saldo parziale" field="saldato" :currentSortField="sortField"
                            :sortDirection="sortDirection" @sort="sort" />
                        <th class="py-2 px-4 border-b text-right">Saldo aperto</th>
                        <th class="py-2 px-4 border-b text-left">Destinazione</th>
                        <th class="py-2 px-4 border-b text-center">Stato</th>
                        <th v-if="hasPrintableRata" class="py-2 px-4 border-b text-center">Stampa</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="rata in paginatedRate" :key="rata.id" class="text-sm" :class="{ 'bg-yellow-50': rata.FornitoreCollegato == 1, 'bg-red-50': rata.FornitoreCollegato != 1 && rata.CreditNote == 1 }">
                        <td class="py-2 px-4 border-b text-left">{{ formatDate(rata.InstallmentDate) }}</td>
                        <td class="py-2 px-4 border-b text-left">{{ rata.DocNo }}</td>
                        <td class="py-2 px-4 border-b text-left">{{ formatDate(rata.DocumentDate) }}</td>
                        <td class="py-2 px-4 border-b text-left" :class="{ 'text-red-600': rata.CreditNote == 1 }">
                            {{ rata.Description }}
                        </td>
                        <td class="py-2 px-4 border-b text-right">{{ formatCurrency(rata.Amount) }}</td>
                        <td class="py-2 px-4 border-b text-right">{{ formatCurrency(rata.saldato) }}</td>
                        <td class="py-2 px-4 border-b text-right">{{ formatCurrency(rata.Amount - rata.saldato) }}</td>
                        <td class="py-2 px-4 border-b text-left">{{ rata.Destinazione }}</td>
                        <td class="py-2 px-4 border-b text-center">
                            <span v-if="rata.Settled == 1" class="bg-green-100 text-green-800 p-1 border-green-400 border rounded-md flex-nowrap">Saldato</span>
                            <span v-if="rata.Settled == 0 && checkDatePayment(rata.InstallmentDate)" class="bg-red-100 text-red-800 p-1 border-red-400 border rounded-md flex-nowrap">Scaduta</span>
                            <span v-if="rata.Settled == 0 && !checkDatePayment(rata.InstallmentDate)" class="bg-blue-100 text-blue-800 p-1 border-blue-400 border rounded-md flex-nowrap">Da&nbsp;saldare</span>
                        </td>
                        <td v-if="hasPrintableRata" class="py-2 px-4 border-b text-center">
                            <button v-if="rata.FornitoreCollegato == 1 && recuperaDatiDms && rata.PurchaseDocId" @click="printfatturaAcquisto(rata.PurchaseDocId)">Stampa fattura</button>
                            <button v-else-if="rata.FornitoreCollegato != 1 && rata.SaleDocId" @click="printfattura(rata.SaleDocId)">Stampa fattura</button>
                        </td>
                    </tr>
                    <tr v-if="paginatedRate.length === 0">
                        <td :colspan="hasPrintableRata ? 9 : 8" class="py-4 px-4 text-center text-gray-500">Nessun risultato trovato</td>
                    </tr>
                </tbody>
            </table>

            <ClientPagination 
                :currentPage="currentPage" 
                :totalPages="totalPages" 
                @page-changed="onPageChanged" 
            />
        </div>
    </div>
</template>

<script>
import { Link, router, useForm } from '@inertiajs/vue3';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import SortableTableHeader from '@/Components/SortableTableHeader.vue';
import ClientPagination from '@/Components/ClientPagination.vue';
import currencyMixin from '@/mixins/currencyMixin.js';
import Datepicker from 'vue3-datepicker';
import { it } from 'date-fns/locale';

export default {
    mixins: [currencyMixin],
    props: ['rate', 'dettagliAzienda', 'recuperaDatiDms'],
    components: {
        Link,
        BreadCrumbs,
        SortableTableHeader,
        ClientPagination,
        Datepicker
    },
    data() {
        return {
            sortField: this.sort,
            sortDirection: this.direction || 'asc',
            dataInizio: '',
            dataFine: '',
            hideSettledItems: true,
            showLinkedSupplierItems: false,
            currentPage: 1,
            perPage: 10,
            dateFormat: 'dd/MM/yyyy',
            dateLocale: it,
            navigation: [
                { name: 'Dashboard', href: route('dashboard') },
                { name: 'Estratto conto', href: route('modules.home', 'estratto-conto') },
                { name: this.dettagliAzienda.CompanyName, href: route('modules.estratto-conto.dettagli', this.dettagliAzienda.CustSupp) }
            ]
        };
    },
    computed: {
        situazioneCliente() {
            const rows = this.showLinkedSupplierItems
                ? this.rate
                : this.rate.filter(rata => rata.FornitoreCollegato != 1);

            const today = new Date();
            today.setHours(0, 0, 0, 0);

            let TotaleAScadere = 0;
            let TotaleScaduto = 0;
            let NoteCreditoAttive = 0;
            let NoteCreditoScadute = 0;

            rows.forEach(rata => {
                let nettoAperto = rata.Settled == 1 ? 0 : (parseFloat(rata.Amount) || 0) - (parseFloat(rata.saldato) || 0);
                const scaduta = rata.InstallmentDate && new Date(rata.InstallmentDate) < today;

                if (rata.FornitoreCollegato == 1) {
                    nettoAperto = -nettoAperto;
                }

                if (rata.CreditNote == 1) {
                    if (scaduta) {
                        NoteCreditoScadute += nettoAperto;
                    } else {
                        NoteCreditoAttive += nettoAperto;
                    }
                } else {
                    if (scaduta) {
                        TotaleScaduto += nettoAperto;
                    } else {
                        TotaleAScadere += nettoAperto;
                    }
                }
            });

            const Saldo = TotaleAScadere + TotaleScaduto - NoteCreditoAttive - NoteCreditoScadute;

            return { Saldo, TotaleAScadere, TotaleScaduto, NoteCreditoAttive, NoteCreditoScadute };
        },
        filteredRate() {
            let filtered = [...this.rate];

            // Filtro per partite fornitore collegate
            if (!this.showLinkedSupplierItems) {
                filtered = filtered.filter(rata => rata.FornitoreCollegato != 1);
            }

            // Filtro per partite saldate
            if (this.hideSettledItems) {
                filtered = filtered.filter(rata => {
                    const residuo = rata.Amount - rata.saldato;
                    return residuo > 0.01; // Considera saldate quelle con residuo <= 0.01
                });
            }

            // Filtro per data inizio
            if (this.dataInizio) {
                const startDate = new Date(this.dataInizio);
                filtered = filtered.filter(rata => {
                    const rataDate = new Date(rata.InstallmentDate);
                    return rataDate >= startDate;
                });
            }

            // Filtro per data fine
            if (this.dataFine) {
                const endDate = new Date(this.dataFine);
                filtered = filtered.filter(rata => {
                    const rataDate = new Date(rata.InstallmentDate);
                    return rataDate <= endDate;
                });
            }

            // Ordinamento
            if (this.sortField) {
                filtered.sort((a, b) => {
                    let aVal = a[this.sortField];
                    let bVal = b[this.sortField];

                    // Gestione date
                    if (this.sortField === 'InstallmentDate' || this.sortField === 'DocumentDate') {
                        aVal = new Date(aVal);
                        bVal = new Date(bVal);
                    }
                    // Gestione numeri (Amount e altri campi numerici)
                    else if (this.sortField === 'Amount') {
                        aVal = parseFloat(aVal) || 0;
                        bVal = parseFloat(bVal) || 0;
                    }

                    if (aVal < bVal) return this.sortDirection === 'asc' ? -1 : 1;
                    if (aVal > bVal) return this.sortDirection === 'asc' ? 1 : -1;
                    return 0;
                });
            }

            return filtered;
        },
        totalPages() {
            return Math.ceil(this.filteredRate.length / this.perPage);
        },
        paginatedRate() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.filteredRate.slice(start, end);
        },
        hasPrintableRata() {
            return this.paginatedRate.some(rata =>
                (rata.FornitoreCollegato == 1 && this.recuperaDatiDms && rata.PurchaseDocId) ||
                (rata.FornitoreCollegato != 1 && rata.SaleDocId)
            );
        }
    },
    watch: {
        filteredRate() {
            // Reset to first page when filters change
            this.currentPage = 1;
        }
    },
    methods: {
        sort(field) {
            if (this.sortField === field) {
                this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
            } else {
                this.sortField = field;
                this.sortDirection = 'asc';
            }
        },
        formatDate(dateString) {
            if (!dateString) return '';
            return new Date(dateString).toLocaleDateString('it-IT');
        },
        checkDatePayment(dateString) {
            if (!dateString) return false;
            const today = new Date();
            const paymentDate = new Date(dateString);
            // Reset time to compare only dates
            today.setHours(0, 0, 0, 0);
            paymentDate.setHours(0, 0, 0, 0);
            return paymentDate < today;
        },
        onPageChanged(page) {
            this.currentPage = page;
        },
        printfattura(docid) {
        // Apre la stampa in una nuova finestra
        const printUrl = this.recuperaDatiDms
            ? route('modules.estratto-conto.stampafatturadms', docid)
            : route('modules.estratto-conto.stampafattura', docid);
        window.open(printUrl, '_blank');
        },
        printfatturaAcquisto(purchaseDocId) {
        // Apre il documento DMS della fattura fornitore in una nuova finestra
        const printUrl = route('modules.estratto-conto.stampafatturaacquistodms', purchaseDocId);
        window.open(printUrl, '_blank');
        },
    }
};
</script>